import { render, staticRenderFns } from "./changeWork.vue?vue&type=template&id=07113f3d&scoped=true"
import script from "./changeWork.vue?vue&type=script&lang=js"
export * from "./changeWork.vue?vue&type=script&lang=js"
import style0 from "./changeWork.vue?vue&type=style&index=0&id=07113f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07113f3d",
  null
  
)

export default component.exports